import { render, staticRenderFns } from "./CompButtonCustom.vue?vue&type=template&id=321b4b60&scoped=true"
import script from "./CompButtonCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./CompButtonCustom.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompButtonCustom.vue?vue&type=style&index=0&id=321b4b60&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b4b60",
  null
  
)

export default component.exports